module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/heart-3dc04c8027ce09cac19c043a17b15ac7.svg";